import { Base64 } from "js-base64";

import { Maybe } from "types/generated";

export const formatApiSecretFile = (secret: Maybe<string>, id: string) => {
  try {
    const encodedSecret = Base64.encode(`api:${id}:${secret || ""}`, true);

    return `Please use the following API secret when communicating with Spacelift
programmatically:

${secret || ""}

Please add this snippet to your .terraformrc file if you want to use this API
key to access Spacelift-hosted Terraform modules outside of Spacelift:

credentials "spacelift.io" {
token = "${encodedSecret}"
}
`;
  } catch {
    return undefined;
  }
};
